import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Link from 'react-router-dom/Link'
import config from 'config'

import CodeVerificationBox from 'srcReact/components/common2/CodeVerificationBox'
import Button from 'srcReact/components/common2/Button'
import Icon from 'srcReact/components/icons/Icon'

import { settingsActions } from '../../action'
import styles from './styles.module.scss'
import { loginActions } from 'srcReact/LoginPage'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

export default function VerificationForm() {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { userDetails, password, updatedEmail, credValue, emailValidationSuccess, emailValidationFailure } =
    useSelector((state) => state.settings)
  const { phone_number } = userDetails

  const [code, setCode] = useState('')
  const [codeError, setCodeError] = useState(false)
  const [emailValidatePayload, setEmailValidatePayload] = useState('')
  const [success, setSuccess] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if (emailValidationFailure && !emailValidationFailure.success) {
      setCodeError(true)
      setErrorMessage(emailValidationFailure)
      dispatch(settingsActions.setInitial())
    } else if (emailValidationSuccess && emailValidationSuccess.email) {
      dispatch(settingsActions.putEmail(emailValidatePayload))
      setCodeError(false)
      setSuccess(true)
      dispatch(settingsActions.setInitial())
      setTimeout(() => {
        dispatch(loginActions.userLogout())
      }, 1000)
    }
  }, [emailValidationSuccess, emailValidationFailure])

  const handleCode = (e) => {
    setCode(e.toString())
  }

  const handleCodeVerification = () => {
    validateCode(code)
  }

  const handleCancel = () => {
    dispatch(settingsActions.setInitial())
    dispatch(settingsActions.setVerificationFormActive(false))
  }

  const validateCode = (code) => {
    let payload = {
      email: updatedEmail,
      activation_code: code.toUpperCase()
    }
    setEmailValidatePayload(payload)
    dispatch(settingsActions.setEmailCodeValidation(payload))
    setCodeError(false)
    return true
  }

  const handleSendAgain = () => {
    let payload = {
      email: updatedEmail
    }
    dispatch(settingsActions.setEmailActivationCode(payload))
  }

  const handleClose = () => {
    dispatch(settingsActions.setUpdateFormActive(false))
    dispatch(settingsActions.setVerificationFormActive(false))
  }
  const getTitle = (type) => {
    if (type == 'email') {
      return t('account_settings.update_form.changeEmail')
    } else if (type === 'password') {
      return t('account_settings.update_form.changePassword')
    } else if (type === 'number') {
      return t('account_settings.update_form.changeNumber')
    }
  }
  const hasSubtitle = (type) => {
    if (type === 'email' && updatedEmail) {
      return true
    } else if (type === 'number' && phone_number) {
      return true
    }
    return false
  }

  const getSubTitle = (type) => {
    let title =
      type === 'email'
        ? t('account_settings.update_form.currentEmail')
        : type === 'number'
        ? t('account_settings.update_form.currentNumber')
        : ''
    let value = type === 'email' ? updatedEmail : type === 'number' ? phone_number : ''

    return (
      <div className={`${styles.currentCred}`}>
        {title}
        <span>{value}</span>
      </div>
    )
  }

  return (
    <div className={`${styles.mainWrapper}`}>
      <div className={`${styles.boxWrapper}`}>
        <div className={`${styles.closeIcon}`} onClick={handleClose}>
          <Icon name='close' alt='' />
        </div>
        <header className={`${styles.header}`}>{getTitle(credValue)}</header>
        {hasSubtitle(credValue) && getSubTitle(credValue)}
        {success ? (
          <div className={`${styles.successBlock}`}>
            <img src={config.assetUrl + '/images/check.png'} alt='success' />
            <h2>
              {' '}
              {t('account_settings.verification_form.your') +
                credValue +
                t('account_settings.verification_form.success')}
            </h2>
          </div>
        ) : (
          <div className={`${styles.formWrapper}`}>
            <CodeVerificationBox
              autoFocus={false}
              customClassName={styles.codeInput}
              fields={5}
              onChange={handleCode}
              type='text'
              isValid={false}
              inputStyleInvalid={styles.codeError}
            />
            {codeError && <ErrorMessage text={errorMessage} className={styles.errorText} />}
            <Button
              text={t('account_settings.verification_form.confirm')}
              handleClick={handleCodeVerification}
              customStyle={styles.sendButton}
              size='large'
            />
            <div className={`${styles.linkBox}`}>
              <Link to='/0/settings/account/update-email' className={`${styles.cancelLink}`} onClick={handleSendAgain}>
                {t('global.sendAgain')}
              </Link>
              <p className={`${styles.or}`}>{t('account_settings.verification_form.or')}</p>
              <Link to='/0/settings/account' className={`${styles.cancelLink}`} onClick={handleCancel}>
                {t('account_settings.verification_form.cancel_email')}
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
